// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require('jquery')

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

require("packs/smooth-scroll.js")
require("packs/slick.min.js")

$(window).on('load', function () {
  if (typeof inputed_operation_status === 'undefined') return;

  var input_operation_status = inputed_operation_status;//get data by javascript_tag
  var work_days_selected = work_days;
  var career_status_selected = career_status;
  if (input_operation_status === false) {
    $('input:radio[name=radio]').filter('[value=' + work_days_selected + ']').attr('checked', true);
    // チェックボックスについては、デフォルトは「何も選択していない状態」とする
    $('input:checkbox[name=checkbox]').prop('checked', false);
    $('.modal001_update_info_popup').fadeIn();
    $(".btn-submit").on('click', function () {
      var loading = document.getElementById("loading");
      loading.style.display = "block";
      $('input[type="submit"]').attr('disabled', true);
      $('input[type="radio"]').attr('disabled', true);
      $('input[type="checkbox"]').attr('disabled', true);
      var dimmed = document.getElementById("modal-dimmed");
      dimmed.classList.add("is-dimmed");
      var volume_radio_info = $('input[name="radio"]:checked').val();
      var volume_check_info = $('input[name="checkbox"]:checked').map(function () { return this.value; }).get();
      mydata = {
        profile: {
          work_days: volume_radio_info,
          career_status: volume_check_info
        }
      };
      var fd = new FormData();
      fd.append("jsondata", JSON.stringify(mydata));
      $.ajax({
        type: "POST",
        url: "/service-pw/update_info_volume",
        data: fd,
        cache: false,
        contentType: false,
        processData: false,
        dataType: "json"
      }).done(function (result) {
        if (!volume_radio_info || volume_check_info.length === 0) {
          return false;
        } else {
          $('.modal001_update_info_popup').fadeOut();
          return false;
        }
      }).fail(function () {
        return false;
      }).always(function () {
        loading.style.display = "none";
        $('input[type="submit"]').attr('disabled', false);
        $('input[type="radio"]').attr('disabled', false);
        $('input[type="checkbox"]').attr('disabled', false);
        dimmed.classList.remove("is-dimmed");
        return false;
      });
    });
  }
});